import RetryErrorDialog from "@/components/RetryErrorDialog.vue";
import { Dialog, useQuasar } from "quasar";
import { onBeforeRouteLeave, useRouter } from "vue-router";

export function useRetryErrorDialog() {
    const $q = useQuasar();
    const router = useRouter();

    // Holds the active dialog's hide() so it can be dismissed externally.
    let activeDismiss: (() => void) | null = null;
    // Set to true when a route leave causes the dismiss so .onCancel() skips router.back().
    let isNavigating = false;

    // Registered synchronously during setup so it's within the component lifecycle context.
    onBeforeRouteLeave(() => {
        isNavigating = true;
        activeDismiss?.();
    });

    const dialog = $q ? $q.dialog : Dialog.create;

    function showRetryError(options: {
        message: string;
        title?: string;
        error?: Error;
        showBack?: boolean;
        onRetry: () => void;
        onBack?: () => void;
    }) {
        isNavigating = false;

        dialog({
            component: RetryErrorDialog,
            componentProps: {
                message: options.message,
                title: options.title,
                error: options.error,
                showBack: options.showBack,
                registerDismiss: (fn: () => void) => {
                    activeDismiss = fn;
                }
            }
        })
            .onOk(() => {
                activeDismiss = null;
                options.onRetry();
            })
            .onCancel(() => {
                activeDismiss = null;
                if (!isNavigating) {
                    if (typeof options.onBack === "function") {
                        options.onBack();
                    } else {
                        router.back();
                    }
                }
            })
            .onDismiss(() => {
                activeDismiss = null;
                isNavigating = false;
            });
    }

    return { showRetryError };
}
